<template>
  <div class="contents-header">
    <div class="chinner">

      <BreadCrumbs>
        <li class="bcli"><slot name="title01"></slot>をのぞく</li>
      </BreadCrumbs>

      <h1 class="pagetitle _white"><slot name="title01"></slot>をのぞく</h1>

      <dl class="job-explain">
        <dt class="dt"><span class="dtin">業界説明</span></dt>
        <dd class="dd -long _mb40">
          <slot name="explain01"></slot>
        </dd>
        <dt class="dt"><span class="dtin">業務のやりがい</span></dt>
        <dd class="dd -short"><slot name="yarigai01"></slot></dd>
        <dd class="dd -short"><slot name="yarigai02"></slot></dd>
        <dd class="dd -short"><slot name="yarigai03"></slot></dd>
      </dl>
      <div class="chimg" :class="startAnim">
        <slot name="img-headbg"></slot>
        <slot name="img-headp"></slot>
      </div>
    </div><!-- .chinner -->
  </div><!-- .contents-header -->
</template>

<script>
  export default {
    data(){
      return{
        startAnim: ""
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        // ビュー全体がレンダリングされた後にのみ実行されるコード
        this.startAnim = "-active";
      })
    },

  }
</script>